const blurbs = [
  "Lively gestural glimmers celebrating the soft symbols of sound.",
  "Animated patterns depicting the emotional responses of different locales.",
  "A celebratory package of illustrations that brings text to life.",
  "Sprinkled outlines exploring the DIY nature of end-of-year connection.",
  "Symbols representative of plants, podcasts, and the spirit of every state.",
  "Editorial stills from a campaign celebrating what music looks like.",
  "A series of illustrations exploring the science of celebratory moods.",
  "Soft outlines and lively patterns depicting the art of different materials.",
  "An animated roundup of gestural glimmers across locales and instruments.",
  "Posters from a campaign where community comes together through illustration.",
];

export const randomBlurb = blurbs[Math.floor(Math.random() * blurbs.length)];

export default blurbs;
